import { useEffect } from "react";
import { GeneralStats } from "@cede/types";
import { QueryKeys } from "@cede/utils";
import { subscribeToStatsDeltas } from "./statsSseBridge";
import { useQueryClient } from "@tanstack/react-query";
import Decimal from "decimal.js";

/**
 * Applies real-time global-stats deltas to the React Query cache. The deltas now
 * ride the notifications SSE (owned by `useNotifications`, Hub-only server-side)
 * and reach us via the stats bridge — no dedicated socket. `enable` (the realtime
 * feature flag) only gates whether we subscribe; a delta for an unmounted stats
 * cache is a no-op.
 *
 * @param enable - Whether to apply real-time deltas.
 */
export const useRealtimeStats = (enable: boolean) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!enable) return;

    return subscribeToStatsDeltas((delta) => {
      queryClient.setQueryData<GeneralStats>([QueryKeys.GENERAL_STATS], (currentStats) => {
        if (!currentStats) return currentStats;
        return {
          ...currentStats,
          totalVolumeTraded: currentStats.totalVolumeTraded.add(new Decimal(delta.volumeDelta)),
          totalNumberOfTrades: currentStats.totalNumberOfTrades + delta.tradesDelta,
        };
      });
    });
  }, [enable, queryClient]);
};
